import { CultureInfo } from '../culture-info.model';
import { CultureInfoEe } from './ee';

/**
 * @ignore
 */
export const CultureInfoEeTG: CultureInfo = {
  name: 'ee-TG',
  displayName: 'Eʋegbe (Togo nutome)',
  iso3LanguageCode: 'ewe',
  iso2LanguageCode: 'ee',
  ietfLanguageTag: 'ee-TG',
  parent: CultureInfoEe
};
